/**
 * The full app's current tab, for things outside MainApp that care (the "get
 * the app" banner shows on My Day only). MainApp keeps the tab in component
 * state and strips ?tab= from the address, so the URL can't tell (review
 * 2026-10-08: the banner's My-Day-only check passed on every tab).
 */
export const ACTIVE_TAB_EVENT = "trybeup:active-tab";

let current: string | null = null;

export function getActiveAppTab(): string | null {
  return current;
}

export function setActiveAppTab(tab: string | null): void {
  if (tab === current) return;
  current = tab;
  try { window.dispatchEvent(new CustomEvent(ACTIVE_TAB_EVENT, { detail: tab })); } catch { /* old WebView */ }
}
